import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f066a5f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Suggest" }
const _hoisted_2 = ["onMousedown"]
const _hoisted_3 = { class: "suggest_item" }

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSuggest',
  props: {
  suggestData: {
    type: Array as PropType<string[]>,
    required: true,
  },
},
  emits: ["selectSuggest"],
  setup(__props, { emit: __emit }) {


const emit = __emit;
// 候補のクリック
const selectSuggest = (data: string) => {
  emit("selectSuggest", data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.suggestData, (data, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "Search_Suggest_Content Move_With_Allow",
          key: index,
          onMousedown: ($event: any) => (selectSuggest(data))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(data), 1)
        ], 40, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})